import CircularProgress from "@mui/material/CircularProgress";
import DialogInOne from "./DialogInOne";
import { useZusDialogStore } from "../zustand/store";
//for query loading spin, without progress
export default function LoadingDialog(p = { forceOpen: false }) {
  const zusDialog = useZusDialogStore();
  const isOpen = p.forceOpen ? true : zusDialog.matchExtra("loadingDialog");
  return (
    <DialogInOne
      {...{
        title: "",
        self: {
          open: isOpen,
          onClose: () => zusDialog.close(),
        },
        content: <CircularProgress />,
        onCancel: zusDialog.close,
        onConfirm: () => {},
        isConfirmHidden: true,
        isCancelHidden: true,
        rest: { fullWidth: false },
        isLoadingDialog: true,
      }}
    />
  );
}
